/**
 * Preços exibidos ao consumidor.
 * O servidor cobra 1990 centavos na carta avulsa (e-mail) e 2990 no Premium anual.
 * O browser não envia amount, currency nem price id.
 */

/** Plano Premium. Não usar para o card de carta avulsa. */
export const PREMIUM_ANNUAL_DISPLAY = "R$ 29,90/ano";

/** Carta avulsa por e-mail. Não chamar de Premium. */
export const SINGLE_LETTER_DISPLAY = "R$ 19,90";

/** Valor analítico da tela /sucesso, que é o retorno da carta avulsa. */
export const SINGLE_LETTER_ANALYTICS_VALUE = 19.9;
